import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseAutocomplete from 'common/components/base-autocomplete';
import React from 'react';
// import { useFormContext } from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';
interface IProps {
    name: string;
    options: { label: string; value: string }[];
}
const QuestionTextboxRecommendMultiChoice: React.FC<IProps> = ({
    name,
    options,
}) => {
    // const { watch } = useFormContext();
    // console.log(watch(name));
    return (
        <BaseAutocomplete
            name={name}
            isOptionEqualToValue={(option, value) =>
                option.value === value.value
            }
            endAdornment={
                <SearchIcon
                    sx={{
                        fontSize: [28, 34],
                        color: '#8B8B8B',
                    }}
                />
            }
            multiple={true}
            popupIcon={null}
            sx={{
                '& .MuiInputBase-root': {
                    minHeight: ['3.5rem', '3.5rem', '4rem', '5rem', '5rem'],
                    fontSize: ['1rem', '1rem', '1.5rem', '1.5rem', '1.5rem'],
                    fontWeight: '400',
                    borderRadius: '10px',
                    backgroundColor: common.white,
                },
            }}
            options={options}
            renderOption={(props, option, { selected }) => {
                return (
                    <Box component="li" {...props}>
                        <FormControlLabel
                            value={option?.value}
                            control={<Checkbox />}
                            label={option?.label}
                            checked={selected}
                        />
                    </Box>
                );
            }}
        />
    );
};

export default QuestionTextboxRecommendMultiChoice;
